export const SET_PARTNER_CATEGORIES = "SET_PARTNER_CATEGORIES";
export const SET_PARTNER_CATEGORIES_BY_PARTNER_ID = "SET_PARTNER_CATEGORIES_BY_PARTNER_ID";
export const SET_CREATED_PARTNER_CATEGORY = "SET_CREATED_PARTNER_CATEGORY";
export const SET_UPDATED_PARTNER_CATEGORY = "SET_UPDATED_PARTNER_CATEGORY";
export const REMOVE_DELETED_PARTNER_CATEGORY = "REMOVE_DELETED_PARTNER_CATEGORY";
export const SET_PARTNER_CATEGORY_ERROR = "SET_PARTNER_CATEGORY_ERROR";
export const SET_PARTNER_CATEGORIES_LOADING = "SET_PARTNER_CATEGORIES_LOADING";
export const SET_PARTNER_CATEGORIES_FETCHING = "SET_PARTNER_CATEGORIES_FETCHING";
